import type { GetGoogleAuthenticationUrlAction } from './getAuthenticationUrl.action';
import type { GetGoogleMarketingAdAccountsAction } from './getAdAccounts.action';
import type { GetSanAdAccountZeitStatusAction } from '../../../actions/getSANAdPartnerZeitStatus';

export * from './getAuthenticationUrl.action';
export * from './getAdAccounts.action';

export type GoogleAction =
  | GetGoogleAuthenticationUrlAction
  | GetGoogleMarketingAdAccountsAction
  | GetSanAdAccountZeitStatusAction;
